<template>
  <pt-previous-video-audit class="pt-previous-video-audit__page"></pt-previous-video-audit>
</template>

<script>
import PtPreviousVideoAudit from 'cps/famous-doctor-hall/pt-previous-video-audit/withData'
export default {
  name: 'pt-previous-video-audit__view',
  components: {
    'pt-previous-video-audit': PtPreviousVideoAudit
  }
}
</script>
